/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export const UPDATE_PASSWORD_ACTION: string = 'UPDATE_PASSWORD'; // NOSONAR
export const CONFIGURE_TOTP_ACTION: string = 'CONFIGURE_TOTP';

export interface AuthenticationConfig {
  redirectUriSuffix: string;
  waitForInitialNavgiationToComplete: boolean;
}

export interface IdentityClaims {
  preferred_username: string;
  email: string;
  given_name: string;
  family_name: string;
}

export interface UserInfo {
  organisationEinheitName?: string[];
}

export interface UserProfileResponse {
  info?: UserInfo;
}

export interface ClientRoleClaim {
  roles: string[];
}

export interface AccessTokenClaims {
  resource_access?: Record<string, ClientRoleClaim>;
}
